<template>
  <ul class="check-list">
    <div class="check-list__upper-container">
      <div class="check-list__title">
        We will find the <strong>perfect provider, tariff and features</strong> at
        a <strong>price that's right</strong> for your business.
      </div>
      <hr>
    </div>
    <div class="check-list__subtitle">
      What we'll consider when tailoring your package:
    </div>
    <li v-for="(li, index) in lis" :key="index" class="check-list__item">
      <img :src="checkCircle">
      {{ li.text }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'CheckList',
  props: {
    lis: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      checkCircle: require('@/assets/icons/check-circle.svg')
    }
  }
}
</script>

<style lang="scss" scoped>
.check-list {
  padding-left: 0;
  @media (min-width: 800px) {
    margin-top: 30px !important;
    background: $white;
    border-radius: 12px 0 0 12px;
    padding-top: 45px;
    font-size: 16px;
    width: 440px;
    padding-left: 45px;
    padding-bottom: 45px;
    padding-right: 16px;
    max-height: 400px;
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.12);
  }

  &__subtitle {
    display: none;
    @media (min-width: 800px) {
      display: block;
      margin-bottom: 30px;
      font-size: 14px;
    }
  }

  hr {
    @media (min-width: 800px) {
      margin-top: 30px;
      margin-bottom: 30px;
    }
  }

  &__upper-container {
    display: none;
    @media (min-width: 800px) {
      display: block;
    }
  }

  &__item {
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 13px;

    @media (min-width: 800px) {
      line-height: 26px;
      margin-bottom: 30px;
    }

    & + .check-list__item {
      @media (min-width: 800px) {
        margin-top: 14px;
      }
      @media (min-width: 1024px) {
        margin-top: 18px;
      }
    }
  }

  img {
    margin-right: 10px;

    @media (min-width: 800px) {
      margin-right: 12px;
      font-size: 26px;
    }
  }
}
.check-list__item {
  line-height: 17px;
  color: $black;

  & + .check-list__item {
    margin-top: 7px;
  }
}
@mixin resetList {
  list-style: none;
  margin: 0;
  padding: 0;
}

.check-list {
  text-align: left;

  &__item {
    display: flex;
    align-items: flex-start;
  }

  i {
    color: $valid;
    margin-right: 8px;
  }
}
</style>
